export default {
  allowedMobileOnly: true,
  skipInQuickEditPanel: true,
};
